<template>
  <b-modal
    id="modal-deactivated-automation"
    class="mc-modal"
    title="Nonaktifkan Automasi Perjalanan?"
    header-bg-variant="primary"
    size="md"
    centered
  >
    <p class="mt-2 p-0">
      {{ 'Penugasan' }} <strong>{{ foNumber }}</strong>
      {{ 'akan dijalankan secara manual melalui Admin atau Smart Driver App' }}
    </p>
    <template #modal-footer>
      <McButton
        variant="secondary"
        class="me-2"
        :text="$t('global.action.cancel')"
        @click="$bvModal.hide('modal-deactivated-automation')"
      />
      <McButton
        variant="primary"
        type="submit"
        :text="$t('global.action.nonactivate')"
        @click="handleActivatedAutomation"
      />
    </template>
  </b-modal>
</template>
<script>
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    foNumber: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleActivatedAutomation() {
      this.$emit('deactivated-automation')
      this.$bvModal.hide('modal-deactivated-automation')
    },
  },
}
</script>
